import { IconButton } from "@base-ui";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconButtonRow = function IconButtonRow(_ref) {
  var option = _ref.option,
    handleUpdateList = _ref.handleUpdateList,
    handleCopyList = _ref.handleCopyList,
    handleRemoveList = _ref.handleRemoveList,
    handleSaveList = _ref.handleSaveList;
  return /*#__PURE__*/_jsx("div", {
    style: {
      position: "absolute",
      right: "15px",
      top: 0,
      zIndex: 8
    },
    children: option !== null && option !== void 0 && option.volatile ? /*#__PURE__*/_jsx(IconButton, {
      title: "Spara ".concat(option === null || option === void 0 ? void 0 : option.label),
      label: "Spara ".concat(option === null || option === void 0 ? void 0 : option.label),
      icon: "Save",
      iconSize: "xsm",
      hideBoxshadow: true,
      hideBackgroundColor: true,
      noBorder: true,
      minWidth: "34px",
      padding: "0 8px",
      onClick: function onClick() {
        return handleSaveList(option);
      }
    }) : /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex"
      },
      children: [/*#__PURE__*/_jsx(IconButton, {
        title: "\xC4ndra namn p\xE5 ".concat(option === null || option === void 0 ? void 0 : option.label),
        label: "\xC4ndra namn p\xE5 ".concat(option === null || option === void 0 ? void 0 : option.label),
        icon: "pen",
        iconSize: "xsm",
        hideBoxshadow: true,
        hideBackgroundColor: true,
        noBorder: true,
        minWidth: "34px",
        padding: "0 8px",
        onClick: function onClick() {
          return handleUpdateList(option.id, option.label);
        }
      }), /*#__PURE__*/_jsx(IconButton, {
        title: "Kopiera ".concat(option === null || option === void 0 ? void 0 : option.label),
        label: "Kopiera ".concat(option === null || option === void 0 ? void 0 : option.label),
        icon: "copy",
        iconSize: "xsm",
        hideBoxshadow: true,
        hideBackgroundColor: true,
        noBorder: true,
        minWidth: "34px",
        padding: "0 5px",
        onClick: function onClick() {
          return handleCopyList(option.label);
        }
      }), /*#__PURE__*/_jsx(IconButton, {
        title: "Ta bort ".concat(option === null || option === void 0 ? void 0 : option.label),
        label: "Ta bort ".concat(option === null || option === void 0 ? void 0 : option.label),
        iconSize: "xsm",
        icon: "trashcan",
        hideBoxshadow: true,
        hideBackgroundColor: true,
        noBorder: true,
        minWidth: "34px",
        padding: "0 8px",
        onClick: function onClick() {
          return handleRemoveList(option.id, option.label);
        }
      })]
    })
  });
};
export default IconButtonRow;